// YMM Search Widget V4 – Multi-tag URL format, required fields only
(function(){
    
    var root = document.getElementById('ymm-search');
    if(!root) {
      return;
    }

    // Y5: flag body.ymm-active while the widget has focus so the theme can
    // suppress the Klaviyo popup / $15 teaser during fitment interaction.
    root.addEventListener('focusin', function(){ document.body.classList.add('ymm-active'); });
    root.addEventListener('focusout', function(e){
      if(!root.contains(e.relatedTarget)) document.body.classList.remove('ymm-active');
    });
    
    
    // Get configuration from data attributes
    var layout = root.getAttribute('data-layout') || 'horizontal';
    var visibleFields = parseInt(root.getAttribute('data-visible-fields') || '3');
    var visibleFieldsMobile = parseInt(root.getAttribute('data-visible-fields-mobile') || '3');
    var onlyWithFitments = root.getAttribute('data-only-with-fitments') === 'true';
    var heading = root.getAttribute('data-heading') || 'Search By Vehicle';
    var buttonText = root.getAttribute('data-button-text') || 'Search';
    var buttonColor = '#FFA500';
    var buttonTextColor = '#000000';
    
    // Determine which visible fields count to use based on screen size
    var isMobile = window.innerWidth <= 768;
    var activeVisibleFields = isMobile ? visibleFieldsMobile : visibleFields;

    // Check if we're in the theme editor
    var isThemeEditor = window.Shopify && window.Shopify.designMode;
    
    // ── Juggernaut Dark Theme Styles — Option C Bordered Sections ──
    var css = '\n'
      + '.ymm-search-container{width:100%;max-width:100%;font-family:"Barlow Condensed","Barlow",sans-serif;color:#fff;margin:0;padding:0}\n'
      + '.ymm-search-card{border-radius:8px;overflow:hidden;border:1px solid rgba(255,165,0,0.12);background:transparent;box-shadow:none}\n'
      + '.ymm-search-title{display:flex;align-items:center;gap:10px;margin:0;padding:12px 24px;background:rgba(255,165,0,0.08);border-bottom:1px solid rgba(255,165,0,0.12)}\n'
      + '.ymm-search-title-icon{display:flex;align-items:center;flex-shrink:0}\n'
      + '.ymm-search-title-text{font-family:"Oswald","Impact",sans-serif;font-size:14px;font-weight:700;letter-spacing:3px;text-transform:uppercase;color:#fff}\n'
      + '.ymm-search-title-hint{margin-left:auto;font-family:"Barlow Condensed",sans-serif;font-size:11px;font-weight:500;letter-spacing:1px;color:#555}\n'
      + '.ymm-search-fields-wrap{padding:20px 24px}\n'
      + '.ymm-search-fields-container{margin-bottom:16px}\n'
      + '.ymm-search-fields-container.horizontal{display:flex;align-items:flex-end;gap:12px;flex-wrap:wrap}\n'
      + '.ymm-search-fields-container.vertical{display:flex;flex-direction:column;gap:12px}\n'
      + '.ymm-search-field-group{display:flex;flex-direction:column;min-width:0;flex:1 1 180px;position:relative}\n'
      + '.ymm-search-field-group label{display:block;font-family:"Barlow Condensed",sans-serif;font-size:11px;font-weight:600;letter-spacing:2px;text-transform:uppercase;margin-bottom:6px;color:#888;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}\n'
      + '.ymm-search-field-group select{width:100%;height:46px;border:1px solid rgba(255,255,255,0.08);border-radius:6px;padding:0 34px 0 14px;font-family:"Oswald","Impact",sans-serif;font-size:14px;font-weight:600;letter-spacing:1px;text-transform:uppercase;background:#0d0d0d;color:#fff;transition:border-color 0.25s;min-width:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-image:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'12\' fill=\'none\' stroke=\'%23444\' stroke-width=\'2\'%3E%3Cpath d=\'M2 4l4 4 4-4\'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 12px center}\n'
      + '.ymm-search-field-group select:not(:disabled){border-color:rgba(255,165,0,0.3);background-image:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'12\' fill=\'none\' stroke=\'%23FFA500\' stroke-width=\'2\'%3E%3Cpath d=\'M2 4l4 4 4-4\'/%3E%3C/svg%3E")}\n'
      + '.ymm-search-field-group select:focus{outline:none;border-color:#FFA500;box-shadow:0 0 0 2px rgba(255,165,0,0.15)}\n'
      // Disabled selects: pointer-events:none lets the tap pass through to
      // the field group so the locked-field hint fires instead of the tap
      // being silently swallowed (the Y1 dead click).
      + '.ymm-search-field-group select:disabled{opacity:0.35;cursor:not-allowed;pointer-events:none}\n'
      // Tooltip, not a bar: the old full-width orange pill read as a button and
      // overlapped the field below. Small dark bubble + caret, floating ABOVE
      // the field the user should fill (anchored to the first EMPTY field).
      + '.ymm-search-field-hint{position:absolute;left:50%;bottom:calc(100% + 8px);top:auto;z-index:6;background:#26262b;color:#f6f6f4;border:1px solid rgba(255,255,255,0.14);box-shadow:0 4px 14px rgba(0,0,0,0.45);font-family:"Barlow",sans-serif;font-size:12.5px;font-weight:600;letter-spacing:0.2px;text-transform:none;text-align:center;padding:7px 12px;border-radius:6px;opacity:0;transform:translateX(-50%) translateY(4px);transition:opacity .2s,transform .2s;pointer-events:none;white-space:nowrap}\n'
      + '.ymm-search-field-hint::after{content:"";position:absolute;top:100%;left:50%;transform:translateX(-50%);border:5px solid transparent;border-top-color:#26262b}\n'
      + '.ymm-search-field-hint--show{opacity:1;transform:translateX(-50%) translateY(0)}\n'
      // Freshly-unlocked field flashes its border so the eye tracks the cascade
      + '@keyframes ymm-search-unlock{0%{border-color:#FFA500;box-shadow:0 0 0 2px rgba(255,165,0,0.25)}100%{border-color:rgba(255,165,0,0.3);box-shadow:none}}\n'
      + '.ymm-search-field-group select.ymm-just-unlocked{animation:ymm-search-unlock .5s ease-out}\n'
      // Load error + retry
      + '.ymm-search-error{padding:20px 24px;text-align:center}\n'
      + '.ymm-search-error__text{font-family:"Barlow Condensed",sans-serif;font-size:13px;letter-spacing:0.5px;color:#B0B0B0;margin-bottom:12px;line-height:1.5}\n'
      + '.ymm-search-error__retry{display:inline-flex;align-items:center;justify-content:center;gap:6px;height:40px;padding:0 22px;border:1.5px solid rgba(255,165,0,0.4);border-radius:6px;background:rgba(255,165,0,0.12);font-family:"Oswald","Impact",sans-serif;font-size:13px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#FFA500;cursor:pointer}\n'
      + '.ymm-search-error__retry:hover{background:rgba(255,165,0,0.2);border-color:#FFA500}\n'
      + '.ymm-search-field-group select option{background:#0d0d0d;color:#fff}\n'
      + '.ymm-search-btn{display:flex;align-items:center;justify-content:center;gap:8px;height:46px;padding:0 32px;border:none;border-radius:6px;font-family:"Oswald","Impact",sans-serif;font-size:14px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#000;background:#FFA500;cursor:pointer;transition:background 0.25s;flex-shrink:0;text-decoration:none;line-height:46px;text-align:center}\n'
      + '.ymm-search-btn:hover{background:#E89400}\n'
      + '.ymm-search-btn:active{background:#D08300}\n'
      + '.ymm-search-btn:disabled,.ymm-search-btn[style*="pointer-events: none"]{opacity:0.4;cursor:not-allowed}\n'
      + '.ymm-search-btn svg{display:inline-block;vertical-align:middle}\n'
      + '@media (max-width:768px){.ymm-search-fields-container.horizontal{flex-direction:column;align-items:stretch}.ymm-search-field-group{flex:1 1 100%;min-width:100%}.ymm-search-btn{width:100%;max-width:100%}}\n';
    
    var style = document.createElement('style'); 
    style.textContent = css; 
    document.head.appendChild(style);
    
    // Check for URL parameter (e.g., ?set_ymm=9yy-2022-ford-f150-4x4-3-5l-ecoboost)
    var urlParams = new URLSearchParams(window.location.search);
    var ymmParam = urlParams.get('set_ymm');
    
    // Check for cached vehicle selection
    var cachedSelection = null;
    try {
      var saved = sessionStorage.getItem('ymm_vehicle_selection');
      if(saved) {
        cachedSelection = JSON.parse(saved);
      }
    } catch(e){
    }
    
    // If URL parameter exists, it takes precedence over cached selection
    if(ymmParam){
      // We'll process this after loading field metadata
    }
    
    // Check if we're on a collections or products page
    var currentUrl = window.location.pathname.toLowerCase();
    var isCollectionOrProductPage = currentUrl.indexOf('/collections') !== -1 || currentUrl.indexOf('/products') !== -1;
    
    // Build the widget HTML  
    var searchIcon = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FFA500" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>';
    var btnSearchIcon = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="display:inline-block;vertical-align:middle"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>';
    
    var html = '<div class="ymm-search-container">'
      + '<div class="ymm-search-card">'
      + (cachedSelection 
          ? '<div id="ymm-cached-display" style="margin-bottom:' + (isCollectionOrProductPage ? '0' : '16px') + '"></div>' 
          : '<div class="ymm-search-title"><span class="ymm-search-title-icon">' + searchIcon + '</span><span class="ymm-search-title-text">' + heading + '</span></div>')
      + '<div class="ymm-search-fields-wrap" style="' + (cachedSelection ? 'display:none' : '') + '">'
      + '<div class="ymm-search-fields-container ' + layout + '" id="ymm-search-fields"></div>'
      + ((!cachedSelection || !isCollectionOrProductPage) ? '<a href="#" class="ymm-search-btn" id="ymm-search-btn">' + btnSearchIcon + ' ' + buttonText + '</a>' : '')
      + '</div>'
      + '</div>'
      + '</div>';
    
    // Shell render is a function so the retry path can rebuild it and
    // re-capture element refs (renderSearchError replaces root.innerHTML,
    // which would otherwise leave these refs pointing at detached nodes).
    var fieldsContainer, btn, cachedDisplayEl, clearCacheBtn = null;
    function renderSearchShell(){
      root.innerHTML = html;
      fieldsContainer = root.querySelector('#ymm-search-fields');
      btn = root.querySelector('#ymm-search-btn');
      cachedDisplayEl = root.querySelector('#ymm-cached-display');
      clearCacheBtn = null;
    }
    renderSearchShell();
    
    // Build multi-tag filter path: 9yy-year-2024+9yy-make-ford+9yy-model-f250-super-duty
    function buildTagPath(keys, selection){
      var tags = [];
      keys.forEach(function(key){
        var val = selection[key];
        if(val){
          var slug = String(val).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
          tags.push('9yy-' + key.toLowerCase() + '-' + slug);
        }
      });
      return tags.join('+');
    }

    function buildCachedDisplay(requiredKeys, allKeys){
      if(!cachedDisplayEl || !cachedSelection) return;

      // Display label uses required fields only (optional fields not saved)
      var displayValues = requiredKeys.map(function(key){ return cachedSelection[key] || ''; }).filter(Boolean);
      var vehicleName = displayValues.join(' ');
      var tagPath = buildTagPath(requiredKeys, cachedSelection);
      var currentUrl = window.location.pathname.toLowerCase();
      // Check if URL contains all the expected tags (multi-tag AND filtering)
      var isFiltered = tagPath.split('+').every(function(tag){
        return currentUrl.indexOf(tag) !== -1 || currentUrl.indexOf(encodeURIComponent(tag)) !== -1;
      }) && currentUrl.indexOf('9yy-') !== -1;

      var breadcrumbHTML = '';

      if(isFiltered){
        // State 1: Filtered — all products fit — GREEN
        breadcrumbHTML = '<div style="display:flex;align-items:center;gap:16px;flex-wrap:wrap;padding:16px 24px;background:linear-gradient(135deg,rgba(34,197,94,0.1) 0%,rgba(34,197,94,0.03) 100%);border:1px solid rgba(34,197,94,0.2);border-radius:6px;margin-bottom:16px">'
          + '<div style="width:40px;height:40px;border-radius:8px;background:rgba(34,197,94,0.15);display:flex;align-items:center;justify-content:center;flex-shrink:0">'
          + '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#22C55E" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>'
          + '</div>'
          + '<div style="flex:1 1 220px;min-width:0">'
          + '<div style="font-family:\'Barlow Condensed\',sans-serif;font-size:11px;font-weight:500;letter-spacing:2px;text-transform:uppercase;color:#22C55E;margin-bottom:2px">All products fit your vehicle</div>'
          + '<div style="font-family:\'Oswald\',sans-serif;font-size:18px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#fff;line-height:1.2">' + vehicleName + '</div>'
          + '</div>'
          + '<button id="ymm-clear-cache" style="flex-shrink:0;background:transparent;border:1px solid rgba(255,255,255,0.12);color:#888;cursor:pointer;font-family:\'Barlow Condensed\',sans-serif;font-size:11px;font-weight:600;letter-spacing:2px;text-transform:uppercase;padding:10px 14px;border-radius:4px;transition:border-color 0.25s,color 0.25s;white-space:nowrap">Change ✕</button>'
          + '</div>';
      } else {
        // State 2: Unfiltered — some products may not fit — ORANGE
        var filterUrl = '/collections/all/' + tagPath;
        /* Search results aren't fitment-evaluated — "may not fit" is only
           honest on unfiltered COLLECTION pages. On /search, offer the filter
           instead of implying a verdict. (Theme-copy divergence; upstream.) */
        var ymmEyebrow = (location.pathname.indexOf('/search') === 0)
          ? 'See only parts that fit your vehicle'
          : 'Some products may not fit your vehicle';

        breadcrumbHTML = '<div style="display:flex;align-items:center;gap:16px;flex-wrap:wrap;padding:16px 24px;background:linear-gradient(135deg,rgba(255,165,0,0.1) 0%,rgba(255,165,0,0.03) 100%);border:1px solid rgba(255,165,0,0.2);border-radius:6px;margin-bottom:16px">'
          + '<div style="width:40px;height:40px;border-radius:8px;background:rgba(255,165,0,0.15);display:flex;align-items:center;justify-content:center;flex-shrink:0">'
          + '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#FFA500" stroke-width="2"><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/><path d="M5 17H3v-6l2-5h9l4 5h3v6h-2"/><path d="M5 6h9l4 5H5z"/></svg>'
          + '</div>'
          + '<div style="flex:1 1 220px;min-width:0">'
          + '<div style="font-family:\'Barlow Condensed\',sans-serif;font-size:11px;font-weight:500;letter-spacing:2px;text-transform:uppercase;color:#FFA500;margin-bottom:2px">' + ymmEyebrow + '</div>'
          + '<div style="font-family:\'Oswald\',sans-serif;font-size:18px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#fff;line-height:1.2">' + vehicleName + '</div>'
          + '</div>'
          + '<a href="' + filterUrl + '" style="flex-shrink:0;display:inline-flex;align-items:center;gap:6px;background:#FFA500;color:#000;font-family:\'Oswald\',sans-serif;font-size:12px;font-weight:700;letter-spacing:2px;text-transform:uppercase;padding:10px 18px;border-radius:4px;text-decoration:none;transition:background 0.25s;white-space:nowrap">Products that fit</a>'
          + '<button id="ymm-clear-cache" style="flex-shrink:0;background:transparent;border:1px solid rgba(255,255,255,0.12);color:#888;cursor:pointer;font-family:\'Barlow Condensed\',sans-serif;font-size:11px;font-weight:600;letter-spacing:2px;text-transform:uppercase;padding:10px 14px;border-radius:4px;transition:border-color 0.25s,color 0.25s;white-space:nowrap">Change</button>'
          + '</div>';
      }

      cachedDisplayEl.innerHTML = breadcrumbHTML;
      clearCacheBtn = cachedDisplayEl.querySelector('#ymm-clear-cache');

      // Hover effects for dark theme
      var hoverBtns = cachedDisplayEl.querySelectorAll('button, a[href*="collections"]');
      hoverBtns.forEach(function(b){
        if(b.tagName === 'BUTTON'){
          b.addEventListener('mouseenter', function(){ b.style.borderColor = '#FFA500'; b.style.color = '#FFA500'; });
          b.addEventListener('mouseleave', function(){ b.style.borderColor = 'rgba(255,255,255,0.12)'; b.style.color = '#888'; });
        } else if(b.tagName === 'A'){
          b.addEventListener('mouseenter', function(){ b.style.background = '#E89400'; });
          b.addEventListener('mouseleave', function(){ b.style.background = '#FFA500'; });
        }
      });

      // Setup clear cache handler
      if(clearCacheBtn){
        clearCacheBtn.addEventListener('click', function(e){
          e.preventDefault();
          e.stopPropagation();
          try {
            sessionStorage.removeItem('ymm_vehicle_selection');
            window.location.reload();
          } catch(err){}
          return false;
        });
      }
    }
    
    // Add click handler to prevent form/event hijacking (only if button exists)
    if(btn){
      btn.addEventListener('click', function(e){
        
        // Always prevent default to avoid form submission or other handlers
        e.preventDefault();
        e.stopPropagation();
        
        // Only navigate if enabled and has valid href
        if(btn.style.pointerEvents !== 'none' && btn.href && btn.href !== '#' && btn.href !== window.location.origin + '/#'){
          // Navigate immediately - analytics tracked on page load
          window.location.href = btn.href;
        } else {
        }
        
        return false;
      });
    }
    
    // If in theme editor, show preview UI without loading data
    if(isThemeEditor){
      // Create preview fields
      var previewFields = [
        { key: 'year', label: 'Year' },
        { key: 'make', label: 'Make' },
        { key: 'model', label: 'Model' },
        { key: 'drive', label: 'Drive' },
        { key: 'engine', label: 'Engine' }
      ].slice(0, visibleFields);
      
      previewFields.forEach(function(field, idx){
        var fieldGroup = document.createElement('div');
        fieldGroup.className = 'ymm-search-field-group';
        
        var label = document.createElement('label');
        label.textContent = field.label;
        label.setAttribute('for', 'ymm-search-' + field.key);
        
        var select = document.createElement('select');
        select.id = 'ymm-search-' + field.key;
        select.disabled = idx !== 0;
        
        var defaultOption = document.createElement('option');
        defaultOption.value = '';
        defaultOption.textContent = '- Select ' + field.label + ' -';
        select.appendChild(defaultOption);
        
        if(idx === 0){
          var opt = document.createElement('option');
          opt.value = '2024';
          opt.textContent = '2024';
          select.appendChild(opt);
        }
        
        fieldGroup.appendChild(label);
        fieldGroup.appendChild(select);
        fieldsContainer.appendChild(fieldGroup);
      });
      
      // Disable link in preview
      btn.href = '#';
      btn.style.opacity = '0.5';
      btn.style.pointerEvents = 'none';
      btn.style.cursor = 'not-allowed';
      return;
    }
    
    // Load field definitions and config
    var shop = window.Shopify && window.Shopify.shop ? window.Shopify.shop : '';
    
    // First fetch config to get button colors
    var configUrl = '/apps/ymm/config' + (shop ? '?shop=' + encodeURIComponent(shop) : '');
    
    fetch(configUrl)
      .then(function(r){ return r.ok ? r.json() : Promise.reject('Config fetch failed'); })
      .then(function(configData){
        // Update button colors from config
        if (configData.buttonColor) buttonColor = configData.buttonColor;
        if (configData.buttonTextColor) buttonTextColor = configData.buttonTextColor;
        
        // Apply button colors to the search button
        if(btn){
          btn.style.backgroundColor = buttonColor;
          btn.style.color = buttonTextColor;
        }
        
        // Also apply to any other buttons that might exist (like clear button, filter button, etc.)
        var allButtons = root.querySelectorAll('a[href*="collections"], button[style*="background"]');
        allButtons.forEach(function(button){
          if(button.textContent.indexOf('View Products') !== -1 || button.textContent.indexOf('Search') !== -1){
            button.style.backgroundColor = buttonColor;
            button.style.color = buttonTextColor;
          }
        });
      })
    
    // Load vehicles (allFields=true to get required/optional metadata)
    var params = ['allFields=true'];
    if(shop) params.push('shop=' + encodeURIComponent(shop));
    if(onlyWithFitments) params.push('onlyWithFitments=true');
    var vehiclesUrl = '/apps/ymm/vehicles?' + params.join('&');
    var vehiclesCacheKey = 'ymm_vtree_' + vehiclesUrl;

    // ── Robust vehicle-tree loader ──────────────────────────────────────
    // One upfront fetch; the cascade filters it client-side. A hung fetch
    // used to leave the widget dead (the Y1 60s-stall replay). Fix:
    // sessionStorage cache (instant repeat/back-nav) -> fetch with 10s
    // timeout + one retry -> explicit tap-to-retry on final failure.
    function fetchSearchVehiclesOnce(timeoutMs){
      return new Promise(function(resolve, reject){
        var controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
        var done = false;
        var timer = setTimeout(function(){ if(done) return; done = true; if(controller) controller.abort(); reject(new Error('timeout')); }, timeoutMs);
        fetch(vehiclesUrl, controller ? { signal: controller.signal } : undefined)
          .then(function(r){ if(!r.ok) throw new Error('HTTP error ' + r.status); return r.json(); })
          .then(function(data){ if(done) return; done = true; clearTimeout(timer); resolve(data); })
          .catch(function(err){ if(done) return; done = true; clearTimeout(timer); reject(err); });
      });
    }
    function loadSearchVehicles(onData, onError){
      try {
        var cached = sessionStorage.getItem(vehiclesCacheKey);
        if(cached){ var parsed = JSON.parse(cached); if(parsed && parsed.vehicles){ onData(parsed); return; } }
      } catch(e){}
      fetchSearchVehiclesOnce(10000)
        .catch(function(){ return fetchSearchVehiclesOnce(10000); })
        .then(function(data){ try { sessionStorage.setItem(vehiclesCacheKey, JSON.stringify(data)); } catch(e){} onData(data); })
        .catch(function(err){ onError(err); });
    }
    function renderSearchError(){
      root.innerHTML = '<div class="ymm-search-container"><div class="ymm-search-card"><div class="ymm-search-error"><p class="ymm-search-error__text">Couldn\'t load vehicle options — check your connection.</p><button class="ymm-search-error__retry" id="ymm-search-retry" type="button">Tap to retry</button></div></div></div>';
      var rb = root.querySelector('#ymm-search-retry');
      if(rb) rb.addEventListener('click', function(){ renderSearchShell(); startSearchLoad(); });
    }
    function startSearchLoad(){ loadSearchVehicles(handleSearchData, renderSearchError); }
    startSearchLoad();

    function handleSearchData(data){
        var vehicles = data.vehicles || [];
        var fieldsMetadata = data.fields || [];
        
        
        if(fieldsMetadata.length===0){ 
          root.innerHTML = '<div class="ymm-search-container"><div class="ymm-search-card"><p style="opacity:.7;color:#B0B0B0">No field configuration found.</p></div></div>'; 
          return; 
        }
        
        // Use field metadata from server for correct ordering and labels
        var allFieldKeys = [];
        var requiredFieldKeys = [];
        var optionalFieldKeys = [];
        var fieldLabels = {};
        var fieldTypes = {};
        fieldsMetadata.forEach(function(f){
          allFieldKeys.push(f.key);
          if(f.required) requiredFieldKeys.push(f.key);
          else optionalFieldKeys.push(f.key);
          fieldLabels[f.key] = f.label;
          fieldTypes[f.key] = f.type;
        });

        // Clean up localStorage: strip optional fields from old cached data
        if(cachedSelection){
          var cleanedSelection = {};
          var needsCleanup = false;
          requiredFieldKeys.forEach(function(key){
            if(cachedSelection[key]) cleanedSelection[key] = cachedSelection[key];
          });
          // Check if old data had extra keys (optional fields)
          for(var oldKey in cachedSelection){
            if(requiredFieldKeys.indexOf(oldKey) === -1){
              needsCleanup = true;
              break;
            }
          }
          if(needsCleanup){
            cachedSelection = cleanedSelection;
            try { sessionStorage.setItem('ymm_vehicle_selection', JSON.stringify(cleanedSelection)); } catch(e){}
          }
        }

        // Build cached display — use required keys for slug/tag, all keys for display label
        buildCachedDisplay(requiredFieldKeys, allFieldKeys);
        
        // Process URL parameter if present (e.g., ?set_ymm=9yy-year-2024+9yy-make-ford+9yy-model-f150)
        if(ymmParam){
          try {

            var matchingVehicle = null;

            for(var i = 0; i < vehicles.length; i++){
              var vehicle = vehicles[i];
              var vehicleTagPath = buildTagPath(requiredFieldKeys, vehicle);

              if(vehicleTagPath === ymmParam.toLowerCase()){
                matchingVehicle = vehicle;
                break;
              }
            }
            
            if(matchingVehicle){
              // Only save required fields to localStorage
              var urlSelection = {};
              requiredFieldKeys.forEach(function(key){
                if(matchingVehicle[key]){
                  urlSelection[key] = matchingVehicle[key];
                }
              });


              var hadVehicle = sessionStorage.getItem('ymm_vehicle_selection');

              sessionStorage.setItem('ymm_vehicle_selection', JSON.stringify(urlSelection));
              cachedSelection = urlSelection;
              
              if (!hadVehicle) {
                sessionStorage.setItem('ymm_source', 'deep_link');
              }
              
              
              var currentPath = window.location.pathname;
              var isOnCollection = currentPath.indexOf('/collections/') !== -1;
              
              if(isOnCollection){
                var collectionMatch = currentPath.match(/\/collections\/([^\/]+)/);
                if(collectionMatch){
                  var collectionHandle = collectionMatch[1].split('/')[0];
                  window.location.href = '/collections/' + collectionHandle + '/' + ymmParam;
                  return;
                }
              } else {
                window.location.href = '/collections/all/' + ymmParam;
                return;
              }
            } else {
            }
          } catch(e){
          }
        }
        
        // Only show required fields in search widget (optional fields verified on PDP)
        var fieldKeys = requiredFieldKeys.slice();
        
        // Build cascading dropdowns
        var selects = {};
        var vehicleData = {};

        // Locked-field tap hint: a disabled select swallows the tap, so the
        // tap passes through (pointer-events:none) to its field group, which
        // shows which field to fill first. Turns the Y1 dead click into
        // visible feedback.
        var searchHintTimer = null;
        function showSearchFieldHint(groupEl, msg){
          var existing = groupEl.querySelector('.ymm-search-field-hint');
          if(existing && existing.parentNode) existing.parentNode.removeChild(existing);
          var hint = document.createElement('div');
          hint.className = 'ymm-search-field-hint';
          hint.textContent = msg;
          groupEl.appendChild(hint);
          void hint.offsetWidth;
          hint.classList.add('ymm-search-field-hint--show');
          if(searchHintTimer) clearTimeout(searchHintTimer);
          searchHintTimer = setTimeout(function(){
            hint.classList.remove('ymm-search-field-hint--show');
            setTimeout(function(){ if(hint.parentNode) hint.parentNode.removeChild(hint); }, 250);
          }, 1800);
        }
        
        vehicles.forEach(function(v){
          if(!v) return;
          allFieldKeys.forEach(function(key){
            if(!vehicleData[key]) vehicleData[key] = new Set();
            if(v[key]) vehicleData[key].add(String(v[key]));
          });
        });
        
        // Only create dropdowns for required fields (optional fields handled on PDP)
        requiredFieldKeys.forEach(function(key, idx){
        var fieldGroup = document.createElement('div');
        fieldGroup.className = 'ymm-search-field-group';
        fieldGroup.setAttribute('data-field-index', idx);

        if(idx >= activeVisibleFields){
          fieldGroup.style.display = 'none';
        }
          
          var label = document.createElement('label');
          label.textContent = fieldLabels[key];
          label.setAttribute('for', 'ymm-search-' + key);
          
          var select = document.createElement('select');
          select.id = 'ymm-search-' + key;
          select.disabled = idx !== 0;
          
          var defaultOption = document.createElement('option');
          defaultOption.value = '';
          defaultOption.textContent = '- Select ' + fieldLabels[key] + ' -';
          select.appendChild(defaultOption);
          
          if(idx === 0 && vehicleData[key]){
            var values = Array.from(vehicleData[key]);
            if(fieldTypes[key] === 'range'){
              values.sort(function(a, b){
                return b.localeCompare(a, undefined, { numeric: true });
              });
            } else {
              values.sort();
            }
            values.forEach(function(val){
              var opt = document.createElement('option');
              opt.value = val;
              opt.textContent = val;
              select.appendChild(opt);
            });
          }
          
          selects[key] = select;
          fieldGroup.appendChild(label);
          fieldGroup.appendChild(select);
          fieldsContainer.appendChild(fieldGroup);

          // Tap on a locked field → hint pointing at the field to fill first.
          (function(groupEl, sel, fieldIdx){
            groupEl.addEventListener('pointerdown', function(){
              if(!sel.disabled) return;
              // Anchor to the FIRST EMPTY field — the one to touch next.
              var tKey = null;
              for(var fi = 0; fi < requiredFieldKeys.length; fi++){
                if(!selects[requiredFieldKeys[fi]] || !selects[requiredFieldKeys[fi]].value){ tKey = requiredFieldKeys[fi]; break; }
              }
              var tGroup = tKey && selects[tKey] ? selects[tKey].closest('.ymm-search-field-group') : groupEl;
              showSearchFieldHint(tGroup || groupEl, 'Choose ' + fieldLabels[tKey || requiredFieldKeys[0]] + ' first');
            });
          })(fieldGroup, select, idx);
        });
        
        // Cascade logic — only required fields
        function updateCascade(changedIndex){
          var selected = {};
          for(var i=0; i<=changedIndex; i++){
            var key = requiredFieldKeys[i];
            selected[key] = selects[key].value;
          }

          var filtered = vehicles.filter(function(v){
            if(!v) return false;
            for(var k in selected){
              if(selected[k] && String(v[k]) !== selected[k]) return false;
            }
            return true;
          });

          if(changedIndex < requiredFieldKeys.length - 1){
            var nextKey = requiredFieldKeys[changedIndex + 1];

            var nextValues = new Set();
            filtered.forEach(function(v){
              if(v[nextKey]) nextValues.add(String(v[nextKey]));
            });

            var nextSelect = selects[nextKey];
            nextSelect.innerHTML = '<option value="">- Select ' + fieldLabels[nextKey] + ' -</option>';
            var sortedValues = Array.from(nextValues);
            if(fieldTypes[nextKey] === 'range'){
              sortedValues.sort(function(a, b){
                return b.localeCompare(a, undefined, { numeric: true });
              });
            } else {
              sortedValues.sort();
            }
            sortedValues.forEach(function(val){
              var opt = document.createElement('option');
              opt.value = val;
              opt.textContent = val;
              nextSelect.appendChild(opt);
            });
            nextSelect.disabled = false;
            // Visible unlock flash so the eye tracks the cascade.
            nextSelect.classList.remove('ymm-just-unlocked');
            void nextSelect.offsetWidth;
            nextSelect.classList.add('ymm-just-unlocked');

            var nextFieldGroup = fieldsContainer.querySelector('[data-field-index="' + (changedIndex + 1) + '"]');
            if(nextFieldGroup){
              nextFieldGroup.style.display = '';
            }

            for(var j=changedIndex+2; j<requiredFieldKeys.length; j++){
              selects[requiredFieldKeys[j]].innerHTML = '<option value="">- Select ' + fieldLabels[requiredFieldKeys[j]] + ' -</option>';
              selects[requiredFieldKeys[j]].disabled = true;

              var fieldGroup = fieldsContainer.querySelector('[data-field-index="' + j + '"]');
              if(fieldGroup && j >= activeVisibleFields){
                fieldGroup.style.display = 'none';
              }
            }

            // Auto-select when the next field has exactly one option — set it
            // and cascade onward (may auto-fill further single-option fields).
            // Runs after downstream is cleared so the recursion isn't undone.
            if(sortedValues.length === 1){
              nextSelect.value = sortedValues[0];
              updateCascade(changedIndex + 1);
            }
          }

        }
        
        // Build collection URL with multi-tag AND filtering
        function buildCollectionUrl(selected){
          return '/collections/all/' + buildTagPath(requiredFieldKeys, selected);
        }

        // Save only required fields to localStorage (optional fields are per-PDP)
        function saveSelection(selected){
          try {
            var requiredOnly = {};
            requiredFieldKeys.forEach(function(key){
              if(selected[key]) requiredOnly[key] = selected[key];
            });
            var hadVehicle = sessionStorage.getItem('ymm_vehicle_selection');
            sessionStorage.setItem('ymm_vehicle_selection', JSON.stringify(requiredOnly));
            if (!hadVehicle) sessionStorage.setItem('ymm_source', 'collection_search');
          } catch(e){}
        }

        // Auto-navigate when all required fields are filled (on collection pages with cached selection)
        function autoNavigate(){
          var selected = {};
          var allFilled = requiredFieldKeys.every(function(key){
            selected[key] = selects[key].value;
            return selected[key];
          });
          if(!allFilled) return;
          saveSelection(selected);
          window.location.href = buildCollectionUrl(selected);
        }

        // Update button for non-collection pages
        function updateButton(){
          if(!btn) return;
          var selected = {};
          var allFilled = requiredFieldKeys.every(function(key){
            selected[key] = selects[key].value;
            return selected[key];
          });
          if(allFilled){
            saveSelection(selected);
            btn.href = buildCollectionUrl(selected);
            btn.style.opacity = '1';
            btn.style.pointerEvents = 'auto';
            btn.style.cursor = 'pointer';
          } else {
            btn.href = '#';
            btn.style.opacity = '0.4';
            btn.style.pointerEvents = 'none';
            btn.style.cursor = 'not-allowed';
          }
        }
        
        // Add change listeners to required fields only
        requiredFieldKeys.forEach(function(key, idx){
          selects[key].addEventListener('change', function(){
            updateCascade(idx);
            // On collection/product pages with cached selection, auto-navigate (no button)
            if(cachedSelection && isCollectionOrProductPage){
              autoNavigate();
            } else {
              updateButton();
            }
          });
        });
        
        // Pre-fill from cache if available
        if(cachedSelection){
          
          requiredFieldKeys.forEach(function(key, idx){
            if(cachedSelection[key] && selects[key]){
              selects[key].value = cachedSelection[key];
              if(idx < requiredFieldKeys.length - 1){
                updateCascade(idx);
              }
            }
          });
        }
        
        // Initial state
        updateButton();
    }
  })();
  
  // Update product links with correct variant IDs on collection pages
  (function(){
    if(window.location.pathname.toLowerCase().indexOf('/collections') === -1) return;

    var cachedSelection = null;
    try {
      var saved = sessionStorage.getItem('ymm_vehicle_selection');
      if(saved) cachedSelection = JSON.parse(saved);
    } catch(e){}
    if(!cachedSelection) return;

    var shop = window.Shopify && window.Shopify.shop ? window.Shopify.shop : '';
    var vehicleParam = encodeURIComponent(JSON.stringify(cachedSelection));
    var apiUrl = '/apps/ymm/search?vehicle=' + vehicleParam + (shop ? '&shop=' + encodeURIComponent(shop) : '');
    var variantMap = null;

    function updateVariantLinks(){
      var links = document.querySelectorAll('a[href*="/products/"]');
      if(links.length === 0) return;

      if(variantMap){ applyVariants(links); return; }

      fetch(apiUrl)
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(data){
          if(!data) return;
          variantMap = {};
          (data.variants || []).forEach(function(gid){
            var pid = gid.split('/variants/')[0].split('/').pop();
            var vid = gid.split('/').pop();
            if(!variantMap[pid]) variantMap[pid] = vid;
          });
          applyVariants(links);
        })
        .catch(function(){});
    }

    function applyVariants(links){
      links.forEach(function(link){
        var href = link.getAttribute('href');
        if(!href || href.indexOf('?variant=') !== -1) return;
        var m = href.match(/\/products\/([^\/\?#]+)/);
        if(!m) return;
        fetch('/products/' + m[1] + '.js')
          .then(function(r){ return r.ok ? r.json() : null; })
          .then(function(p){
            if(!p) return;
            var vid = variantMap[String(p.id)];
            if(vid) link.setAttribute('href', href + (href.indexOf('?') !== -1 ? '&' : '?') + 'variant=' + vid);
          })
          .catch(function(){});
      });
    }

    updateVariantLinks();

    new MutationObserver(function(mutations){
      var hasNew = mutations.some(function(m){
        return Array.from(m.addedNodes).some(function(n){
          return n.nodeType === 1 && n.querySelector && n.querySelector('a[href*="/products/"]');
        });
      });
      if(hasNew) updateVariantLinks();
    }).observe(document.body, { childList: true, subtree: true });
  })();

  // Replace raw 9yy- tag in breadcrumbs with readable vehicle name
  (function(){
    var cachedSelection = null;
    try {
      var saved = sessionStorage.getItem('ymm_vehicle_selection');
      if(saved) cachedSelection = JSON.parse(saved);
    } catch(e){}
    if(!cachedSelection) return;

    var tagMatch = window.location.pathname.match(/\/(9yy-[a-z0-9-]+)/i);
    if(!tagMatch) return;
    var tagPattern = tagMatch[1].toLowerCase();

    // Build display name from cached values that appear in the tag
    var parts = [];
    for(var key in cachedSelection){
      if(!cachedSelection[key]) continue;
      var slug = String(cachedSelection[key]).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      if(tagPattern.indexOf(slug) !== -1) parts.push(cachedSelection[key]);
    }
    var vehicleName = parts.join(' ');
    if(!vehicleName) return;

    function replaceTagInDOM(){
      var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
      var node;
      while(node = walker.nextNode()){
        if(node.nodeValue && node.nodeValue.toLowerCase().indexOf(tagPattern) !== -1){
          node.nodeValue = node.nodeValue.replace(new RegExp(tagPattern, 'gi'), vehicleName);
        }
      }
    }
    replaceTagInDOM();
    setTimeout(replaceTagInDOM, 500);
    setTimeout(replaceTagInDOM, 1000);
  })();